import NumericField, { getNumericFieldRegisterProps } from './NumericField';

const registerProps = getNumericFieldRegisterProps('Invalid down payment value');

const DownPaymentField = props => (
    <NumericField
        leftAdornment="$"
        labelText="Down payment"
        helpText="Most home loans require at least 3% down."
        registerProps={registerProps}
        {...props}
    />
);

export default DownPaymentField;
